module.exports = __webpack_public_path__ + "img/xiaohe.46aa2f85.png";